import axios, { type AxiosInstance } from "axios";

class AzureGraphDataFetcher {
    private readonly axiosInstance: AxiosInstance;

    constructor(token: string) {
        this.axiosInstance = axios.create({
            baseURL: "https://graph.microsoft.com/v1.0/",
        });

        this.axiosInstance.interceptors.request.use(async (config) => {
            config.headers.Authorization = `Bearer ${token}`;
            return config;
        });
    }

    public async getUserManager(id: string): Promise<any> {
        const response = await this.axiosInstance.get(`users/${id}/manager`);
        return response.data;
    }

    public async getMyPhoto(): Promise<any> {
        const response = await this.axiosInstance.get("me/photo/$value", {
            responseType: "blob",
        });
        return response.data;
    }

    public async loadMyPhoto(): Promise<Blob> {
        const response = await this.axiosInstance.get("me/photo/$value", {
            responseType: "blob",
        });
        return response.data;
    }

    public async getPageDescription(id: string): Promise<any> {
        const response = await this.axiosInstance.get(
            `sites/abb.sharepoint.com,34363488-3376-463d-a1c2-59baf4ccf50c,19c5a9f0-f517-44ff-80fb-5f3abadd8c23/lists/25045fb6-cbbf-471d-9cce-576821320a22/items/${id}`
        );
        return response.data;
    }

    public async getNavigation(): Promise<any> {
        const response = await this.axiosInstance.get(
            "sites/abb.sharepoint.com,34363488-3376-463d-a1c2-59baf4ccf50c/lists/ff063682-8990-4416-aa37-1e25008565b0/items?$expand=fields($select=id,title,permissionId,lbuNorway,order0,url,icon,CategoryLookupLookupId)"
        );
        return response.data;
    }

    public async isCurrentUserMemberOfGroup(): Promise<boolean> {
        const response = await this.axiosInstance.get(
            "me/memberOf?$filter=id eq '6667da17-18d7-4449-99ae-8f78ef9b3746'"
        );
        return response.data && response.data.value && response.data.value.length > 0;
    }

    public async isCurrentUserAdminMember(): Promise<boolean> {
        const response = await this.axiosInstance.get(
            "me/memberOf?$filter=id eq '4890f466-e440-4bf1-a050-fde80f8eff2b'"
        );
        return response.data && response.data.value && response.data.value.length > 0;
    }
}

export default AzureGraphDataFetcher;
